import { isBefore } from "date-fns";
import * as Yup from "yup";

const tabelaVendaValidator = Yup.object().shape({
  ativado: Yup.boolean().required("Ativado"),
  descricao: Yup.string()
    .nullable()
    .required("Descrição")
    .min(1, "Descrição deve ter pelo menos 1 caractere"),
  tipoTabela: Yup.string()
    .nullable()
    .oneOf(["POR_PRODUTO", "TODOS_PRODUTOS"], "Tipo de tabela inválido")
    .required("Tipo de tabela "),
  dataInicio: Yup.date().nullable(),
  dataFim: Yup.date()
    .nullable()
    .test(
      "data-fim-maior",
      "Data fim deve ser maior ou igual à data início",
      function (value) {
        const { dataInicio } = this.parent;
        if (!value || !dataInicio) return true;
        return !isBefore(value, dataInicio);
      }
    ),
  horaInicio: Yup.string().nullable(),
  horaFim: Yup.string().nullable(),
  diasSemana: Yup.array().optional().nullable(),
  operacao: Yup.string().nullable(),
  fator: Yup.number().when("tipoTabela", (tipoTabela) => {
      return tipoTabela === "TODOS_PRODUTOS"
        ? Yup
          .number().nullable()
          .required("Fator de preço")
          .min(0.01, "Fator não pode ser zero")
        : Yup.number().nullable().optional()
  }).nullable(),
  grupoProdutoId: Yup.number().nullable(),
  itens: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.string().optional(),
        precoAtual: Yup.number()
          .required("Preço atual ")
          .min(0, "Preço atual não pode ser negativo"),
        operacao: Yup.string().nullable(),
        fator: Yup.number()
          .required("Fator")
          .min(0, "Fator não pode ser negativo"),
        precoPraticado: Yup.number()
          .required("Preço praticado ")
          .min(0, "Preço praticado não pode ser negativo"),
        quantidadeMinima: Yup.number()
          .required("Quantidade mínima")
          .min(0, "Quantidade mínima não pode ser negativa"),
        estProdutoId: Yup.number().required("Produto Id"),
        estTabelaVendaId: Yup.number().optional(),
        empresaId: Yup.number().optional(),
      })
    )
    .when("tipoTabela", {
      is: "POR_PRODUTO",
      then: (schema) =>
        schema
          .min(1, "Adicione pelo menos um item")
          .required("Itens são obrigatórios"),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
});

export default tabelaVendaValidator;
